import QueryProductInfo, {
  UpdateQueryProductResponse,
} from 'src/model/QueryProduct';

export const DEFINED_PRODUCT_UPDATE = 'DEFINED_PRODUCT_UPDATE';
export const SELECTED_PRODUCT_UPDATE = 'SELECTED_PRODUCT_UPDATE';
export const UPDATE_QUERY_PRODUCT_SUCCESS = 'UPDATE_QUERY_PRODUCT_SUCCESS';
export const PRODUCT_INFO_REMOVE = 'PRODUCT_INFO_REMOVE';

export interface QueryProductUpdateAction {
  readonly type: string;
  readonly countryCode: string;
  readonly queryProduct: QueryProductInfo;
}

export const setDefinedProductUpdate = (
  countryCode: string,
  product: QueryProductInfo,
): QueryProductUpdateAction => ({
  type: DEFINED_PRODUCT_UPDATE,
  countryCode,
  queryProduct: product,
});

export const setSelectedProductUpdate = (
  countryCode: string,
  product: QueryProductInfo,
): QueryProductUpdateAction => ({
  type: SELECTED_PRODUCT_UPDATE,
  countryCode,
  queryProduct: product,
});

export const getUpdateQueryProductSuccessAction = (
  response: UpdateQueryProductResponse,
): QueryProductUpdateAction => ({
  type: UPDATE_QUERY_PRODUCT_SUCCESS,
  countryCode: response.countryCode,
  queryProduct: response.queryProduct,
});

export interface RemoveProductInfoAction {
  readonly type: string;
}

export const removeQueryProductInfo = (): RemoveProductInfoAction => ({
  type: PRODUCT_INFO_REMOVE,
});
